"use strict";
/** @module models */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SCURuleDoSleep = exports.SCURuleDoSendWebsocket = exports.SCURuleDoAudioChannel = exports.SCURuleDoAudioChannelAction = exports.SCURuleDoScuTrigger = exports.SCURuleMultiDo = exports.SCURuleDoTest = exports.SCURuleDoLight = exports.SCURuleDoTextToSpeech = exports.SCURuleDoTone = exports.SCURuleDoMute = exports.SCURuleDoLog = exports.SCURuleDoAlert = exports.SCURuleDoRelay = exports.SCURuleDoIfJobUntaggedDecorator = exports.SCURuleDoIfJobMatchesDecorator = exports.SCURuleDoIfNoAPIDecorator = exports.SCURuleDoIfNoJobsDecorator = exports.SCURuleDoIfAlertingDecorator = exports.SCURuleDoIfTimeOfDayDecorator = exports.SCURuleDoIfInputDecorator = exports.SCURuleDoBlockDecorator = exports.SCURuleDoDelayDecorator = exports.SCUActionDecoratorType = exports.SCURuleDoDecorator = exports.SCUActionType = exports.SCURuleDo = void 0;
var cerealParse_1 = require("../cerealParse");
var job_1 = require("./job");
var scuConfig_1 = require("./scuConfig");
var SCURuleDo = /** @class */ (function () {
    function SCURuleDo(action, decorators) {
        this.action = action;
        this.decorators = decorators;
    }
    SCURuleDo.parse = function (o) {
        try {
            var trigger = cerealParse_1.ParseUtils.getEnum(o, 'action', SCUActionType);
            switch (trigger) {
                case SCUActionType.multi:
                    return cerealParse_1.ParseUtils.parseSuccess(new SCURuleMultiDo(cerealParse_1.ParseUtils.getEnum(o, 'action', SCUActionType), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'decorators', SCURuleDoDecorator.parse, 'throw'), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'actions', SCURuleDo.parse, 'throw')));
                case SCUActionType.relay:
                    return SCURuleDoRelay.parse(o);
                case SCUActionType.alert:
                    return SCURuleDoAlert.parse(o);
                case SCUActionType.log:
                    return SCURuleDoLog.parse(o);
                case SCUActionType.mute:
                    return SCURuleDoMute.parse(o);
                case SCUActionType.tone:
                    return SCURuleDoTone.parse(o);
                case SCUActionType.tts:
                    return SCURuleDoTextToSpeech.parse(o);
                case SCUActionType.light:
                    return SCURuleDoLight.parse(o);
                case SCUActionType.test:
                    return SCURuleDoTest.parse(o);
                case SCUActionType.scuTrigger:
                    return SCURuleDoScuTrigger.parse(o);
                case SCUActionType.audioChannel:
                    return SCURuleDoAudioChannel.parse(o);
                case SCUActionType.sendWebsocket:
                    return SCURuleDoSendWebsocket.parse(o);
                case SCUActionType.sleep:
                    return SCURuleDoSleep.parse(o);
                default:
                    return cerealParse_1.ParseUtils.parseFailure("Invalid SCURuleDo Model: Unhandled action '" + SCUActionType[trigger] + "'");
            }
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCURuleDo Model: " + e.message);
        }
    };
    return SCURuleDo;
}());
exports.SCURuleDo = SCURuleDo;
var SCUActionType;
(function (SCUActionType) {
    SCUActionType[SCUActionType["multi"] = 0] = "multi";
    SCUActionType[SCUActionType["relay"] = 1] = "relay";
    SCUActionType[SCUActionType["alert"] = 2] = "alert";
    SCUActionType[SCUActionType["log"] = 3] = "log";
    SCUActionType[SCUActionType["mute"] = 4] = "mute";
    SCUActionType[SCUActionType["tone"] = 5] = "tone";
    SCUActionType[SCUActionType["tts"] = 6] = "tts";
    SCUActionType[SCUActionType["light"] = 7] = "light";
    SCUActionType[SCUActionType["test"] = 8] = "test";
    SCUActionType[SCUActionType["scuTrigger"] = 9] = "scuTrigger";
    SCUActionType[SCUActionType["audioChannel"] = 10] = "audioChannel";
    SCUActionType[SCUActionType["sendWebsocket"] = 11] = "sendWebsocket";
    SCUActionType[SCUActionType["sleep"] = 12] = "sleep";
})(SCUActionType = exports.SCUActionType || (exports.SCUActionType = {}));
var SCURuleDoDecorator = /** @class */ (function () {
    function SCURuleDoDecorator(action) {
        this.action = action;
    }
    SCURuleDoDecorator.parse = function (o) {
        try {
            var action = cerealParse_1.ParseUtils.getEnum(o, 'action', SCUActionDecoratorType);
            switch (action) {
                case SCUActionDecoratorType.delay:
                    return SCURuleDoDelayDecorator.parse(o);
                case SCUActionDecoratorType.ifInput:
                    return SCURuleDoIfInputDecorator.parse(o);
                case SCUActionDecoratorType.ifAlerting:
                    return SCURuleDoIfAlertingDecorator.parse(o);
                case SCUActionDecoratorType.ifNoJobs:
                    return SCURuleDoIfNoJobsDecorator.parse(o);
                case SCUActionDecoratorType.ifNoApi:
                    return SCURuleDoIfNoAPIDecorator.parse(o);
                case SCUActionDecoratorType.ifTimeOfDay:
                    return SCURuleDoIfTimeOfDayDecorator.parse(o);
                case SCUActionDecoratorType.ifJobMatches:
                    return SCURuleDoIfJobMatchesDecorator.parse(o);
                case SCUActionDecoratorType.ifJobUntagged:
                    return SCURuleDoIfJobUntaggedDecorator.parse(o);
                case SCUActionDecoratorType.block:
                    return SCURuleDoBlockDecorator.parse(o);
                default:
                    return cerealParse_1.ParseUtils.parseFailure("Invalid SCURuleDoDecorator Model: Unhandled trigger '" + SCURuleDoDecorator[action] + "'");
            }
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCURuleDoDecorator Model: " + e.message);
        }
    };
    return SCURuleDoDecorator;
}());
exports.SCURuleDoDecorator = SCURuleDoDecorator;
var SCUActionDecoratorType;
(function (SCUActionDecoratorType) {
    SCUActionDecoratorType[SCUActionDecoratorType["delay"] = 0] = "delay";
    SCUActionDecoratorType[SCUActionDecoratorType["ifInput"] = 1] = "ifInput";
    SCUActionDecoratorType[SCUActionDecoratorType["ifAlerting"] = 2] = "ifAlerting";
    SCUActionDecoratorType[SCUActionDecoratorType["ifNoJobs"] = 3] = "ifNoJobs";
    SCUActionDecoratorType[SCUActionDecoratorType["ifNoApi"] = 4] = "ifNoApi";
    SCUActionDecoratorType[SCUActionDecoratorType["ifTimeOfDay"] = 5] = "ifTimeOfDay";
    SCUActionDecoratorType[SCUActionDecoratorType["ifJobMatches"] = 6] = "ifJobMatches";
    SCUActionDecoratorType[SCUActionDecoratorType["ifJobUntagged"] = 7] = "ifJobUntagged";
    SCUActionDecoratorType[SCUActionDecoratorType["block"] = 8] = "block";
})(SCUActionDecoratorType = exports.SCUActionDecoratorType || (exports.SCUActionDecoratorType = {}));
var SCURuleDoDelayDecorator = /** @class */ (function (_super) {
    __extends(SCURuleDoDelayDecorator, _super);
    function SCURuleDoDelayDecorator(action, delay) {
        var _this = _super.call(this, action) || this;
        _this.action = action;
        _this.delay = delay;
        return _this;
    }
    SCURuleDoDelayDecorator.prototype.toJson = function () {
        return {
            action: SCUActionDecoratorType[this.action],
            delay: this.delay,
        };
    };
    SCURuleDoDelayDecorator.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCURuleDoDelayDecorator(cerealParse_1.ParseUtils.getEnum(o, 'action', SCUActionDecoratorType), cerealParse_1.ParseUtils.getNumber(o, 'delay')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCURuleOnAssignment Model: " + e.message);
        }
    };
    return SCURuleDoDelayDecorator;
}(SCURuleDoDecorator));
exports.SCURuleDoDelayDecorator = SCURuleDoDelayDecorator;
var SCURuleDoBlockDecorator = /** @class */ (function (_super) {
    __extends(SCURuleDoBlockDecorator, _super);
    function SCURuleDoBlockDecorator(delay) {
        var _this = _super.call(this, SCUActionDecoratorType.block) || this;
        _this.delay = delay;
        return _this;
    }
    SCURuleDoBlockDecorator.prototype.toJson = function () {
        return {
            action: SCUActionDecoratorType[this.action],
            delay: this.delay,
        };
    };
    SCURuleDoBlockDecorator.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCURuleDoBlockDecorator(cerealParse_1.ParseUtils.getNumber(o, 'delay')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCURuleDoBlockDecorator Model: " + e.message);
        }
    };
    return SCURuleDoBlockDecorator;
}(SCURuleDoDecorator));
exports.SCURuleDoBlockDecorator = SCURuleDoBlockDecorator;
var SCURuleDoIfInputDecorator = /** @class */ (function (_super) {
    __extends(SCURuleDoIfInputDecorator, _super);
    function SCURuleDoIfInputDecorator(action, device, pin, condition) {
        var _this = _super.call(this, action) || this;
        _this.action = action;
        _this.device = device;
        _this.pin = pin;
        _this.condition = condition;
        return _this;
    }
    SCURuleDoIfInputDecorator.prototype.toJson = function () {
        return {
            action: SCUActionDecoratorType[this.action],
            device: this.device,
            pin: this.pin,
            condition: scuConfig_1.SCUIODeviceInputCondition[this.condition],
        };
    };
    SCURuleDoIfInputDecorator.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCURuleDoIfInputDecorator(cerealParse_1.ParseUtils.getEnum(o, 'action', SCUActionDecoratorType), cerealParse_1.ParseUtils.getString(o, 'device'), cerealParse_1.ParseUtils.getNumber(o, 'pin'), cerealParse_1.ParseUtils.getEnum(o, 'condition', scuConfig_1.SCUIODeviceInputCondition)));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCURuleDoIfInputDecorator Model: " + e.message);
        }
    };
    return SCURuleDoIfInputDecorator;
}(SCURuleDoDecorator));
exports.SCURuleDoIfInputDecorator = SCURuleDoIfInputDecorator;
var SCURuleDoIfTimeOfDayDecorator = /** @class */ (function (_super) {
    __extends(SCURuleDoIfTimeOfDayDecorator, _super);
    function SCURuleDoIfTimeOfDayDecorator(action, isNight) {
        var _this = _super.call(this, action) || this;
        _this.action = action;
        _this.isNight = isNight;
        return _this;
    }
    SCURuleDoIfTimeOfDayDecorator.prototype.toJson = function () {
        return {
            action: SCUActionDecoratorType[this.action],
            isNight: this.isNight,
        };
    };
    SCURuleDoIfTimeOfDayDecorator.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCURuleDoIfTimeOfDayDecorator(cerealParse_1.ParseUtils.getEnum(o, 'action', SCUActionDecoratorType), cerealParse_1.ParseUtils.getBoolean(o, 'isNight')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCURuleDoIfTimeOfDayDecorator Model: " + e.message);
        }
    };
    return SCURuleDoIfTimeOfDayDecorator;
}(SCURuleDoDecorator));
exports.SCURuleDoIfTimeOfDayDecorator = SCURuleDoIfTimeOfDayDecorator;
var SCURuleDoIfAlertingDecorator = /** @class */ (function (_super) {
    __extends(SCURuleDoIfAlertingDecorator, _super);
    function SCURuleDoIfAlertingDecorator(action) {
        var _this = _super.call(this, action) || this;
        _this.action = action;
        return _this;
    }
    SCURuleDoIfAlertingDecorator.prototype.toJson = function () {
        return {
            action: SCUActionDecoratorType[this.action],
        };
    };
    SCURuleDoIfAlertingDecorator.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCURuleDoIfAlertingDecorator(cerealParse_1.ParseUtils.getEnum(o, 'action', SCUActionDecoratorType)));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCURuleDoIfAlertingDecorator Model: " + e.message);
        }
    };
    return SCURuleDoIfAlertingDecorator;
}(SCURuleDoDecorator));
exports.SCURuleDoIfAlertingDecorator = SCURuleDoIfAlertingDecorator;
var SCURuleDoIfNoJobsDecorator = /** @class */ (function (_super) {
    __extends(SCURuleDoIfNoJobsDecorator, _super);
    function SCURuleDoIfNoJobsDecorator(action) {
        var _this = _super.call(this, action) || this;
        _this.action = action;
        return _this;
    }
    SCURuleDoIfNoJobsDecorator.prototype.toJson = function () {
        return {
            action: SCUActionDecoratorType[this.action],
        };
    };
    SCURuleDoIfNoJobsDecorator.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCURuleDoIfNoJobsDecorator(cerealParse_1.ParseUtils.getEnum(o, 'action', SCUActionDecoratorType)));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCURuleDoIfNoJobsDecorator Model: " + e.message);
        }
    };
    return SCURuleDoIfNoJobsDecorator;
}(SCURuleDoDecorator));
exports.SCURuleDoIfNoJobsDecorator = SCURuleDoIfNoJobsDecorator;
var SCURuleDoIfNoAPIDecorator = /** @class */ (function (_super) {
    __extends(SCURuleDoIfNoAPIDecorator, _super);
    function SCURuleDoIfNoAPIDecorator(action) {
        var _this = _super.call(this, action) || this;
        _this.action = action;
        return _this;
    }
    SCURuleDoIfNoAPIDecorator.prototype.toJson = function () {
        return {
            action: SCUActionDecoratorType[this.action],
        };
    };
    SCURuleDoIfNoAPIDecorator.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCURuleDoIfNoAPIDecorator(cerealParse_1.ParseUtils.getEnum(o, 'action', SCUActionDecoratorType)));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCURuleDoIfNoAPIDecorator Model: " + e.message);
        }
    };
    return SCURuleDoIfNoAPIDecorator;
}(SCURuleDoDecorator));
exports.SCURuleDoIfNoAPIDecorator = SCURuleDoIfNoAPIDecorator;
var SCURuleDoIfJobMatchesDecorator = /** @class */ (function (_super) {
    __extends(SCURuleDoIfJobMatchesDecorator, _super);
    function SCURuleDoIfJobMatchesDecorator(action, condition) {
        var _this = _super.call(this, action) || this;
        _this.action = action;
        _this.condition = condition;
        return _this;
    }
    SCURuleDoIfJobMatchesDecorator.prototype.toJson = function () {
        return {
            action: SCUActionDecoratorType[this.action],
            condition: this.condition
        };
    };
    SCURuleDoIfJobMatchesDecorator.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCURuleDoIfJobMatchesDecorator(cerealParse_1.ParseUtils.getEnum(o, 'action', SCUActionDecoratorType), cerealParse_1.ParseUtils.getString(o, 'condition')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCURuleDoIfJobMatchesDecorator Model: " + e.message);
        }
    };
    return SCURuleDoIfJobMatchesDecorator;
}(SCURuleDoDecorator));
exports.SCURuleDoIfJobMatchesDecorator = SCURuleDoIfJobMatchesDecorator;
var SCURuleDoIfJobUntaggedDecorator = /** @class */ (function (_super) {
    __extends(SCURuleDoIfJobUntaggedDecorator, _super);
    function SCURuleDoIfJobUntaggedDecorator(tag) {
        var _this = _super.call(this, SCUActionDecoratorType.ifJobUntagged) || this;
        _this.tag = tag;
        return _this;
    }
    SCURuleDoIfJobUntaggedDecorator.prototype.toJson = function () {
        return {
            action: SCUActionDecoratorType[this.action],
            tag: this.tag
        };
    };
    SCURuleDoIfJobUntaggedDecorator.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCURuleDoIfJobUntaggedDecorator(cerealParse_1.ParseUtils.getString(o, 'tag')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCURuleDoIfJobUntaggedDecorator Model: " + e.message);
        }
    };
    return SCURuleDoIfJobUntaggedDecorator;
}(SCURuleDoDecorator));
exports.SCURuleDoIfJobUntaggedDecorator = SCURuleDoIfJobUntaggedDecorator;
var SCURuleDoRelay = /** @class */ (function (_super) {
    __extends(SCURuleDoRelay, _super);
    function SCURuleDoRelay(action, decorators, device, relay, condition) {
        var _this = _super.call(this, action, decorators) || this;
        _this.action = action;
        _this.decorators = decorators;
        _this.device = device;
        _this.relay = relay;
        _this.condition = condition;
        return _this;
    }
    SCURuleDoRelay.prototype.toJson = function () {
        return {
            action: SCUActionType[this.action],
            decorators: this.decorators.map(function (d) { return d.toJson(); }),
            device: this.device,
            relay: this.relay,
            condition: scuConfig_1.SCUIODeviceRelayCondition[this.condition],
        };
    };
    SCURuleDoRelay.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCURuleDoRelay(cerealParse_1.ParseUtils.getEnum(o, 'action', SCUActionType), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'decorators', SCURuleDoDecorator.parse, 'throw'), cerealParse_1.ParseUtils.getString(o, 'device'), cerealParse_1.ParseUtils.getNumber(o, 'relay'), cerealParse_1.ParseUtils.getEnum(o, 'condition', scuConfig_1.SCUIODeviceRelayCondition)));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCURuleDoRelay Model: " + e.message);
        }
    };
    return SCURuleDoRelay;
}(SCURuleDo));
exports.SCURuleDoRelay = SCURuleDoRelay;
var SCURuleDoAlert = /** @class */ (function (_super) {
    __extends(SCURuleDoAlert, _super);
    function SCURuleDoAlert(action, decorators, type, units, synopsis, street, box, priority, crossStreets) {
        var _this = _super.call(this, action, decorators) || this;
        _this.action = action;
        _this.decorators = decorators;
        _this.type = type;
        _this.units = units;
        _this.synopsis = synopsis;
        _this.street = street;
        _this.box = box;
        _this.priority = priority;
        _this.crossStreets = crossStreets;
        return _this;
    }
    SCURuleDoAlert.prototype.toJson = function () {
        return {
            action: SCUActionType[this.action],
            decorators: this.decorators.map(function (d) { return d.toJson(); }),
            type: job_1.JobTypeEnum[this.type],
            units: this.units,
            synopsis: this.synopsis,
            street: this.street,
            box: this.box,
            priority: this.priority,
            crossStreets: this.crossStreets,
        };
    };
    SCURuleDoAlert.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCURuleDoAlert(cerealParse_1.ParseUtils.getEnum(o, 'action', SCUActionType), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'decorators', SCURuleDoDecorator.parse, 'throw'), cerealParse_1.ParseUtils.getEnum(o, 'type', job_1.JobTypeEnum), cerealParse_1.ParseUtils.getArray(o, 'units'), cerealParse_1.ParseUtils.getString(o, 'synopsis'), cerealParse_1.ParseUtils.getString(o, 'street'), cerealParse_1.ParseUtils.getStringOrNull(o, 'box'), cerealParse_1.ParseUtils.getStringOrNull(o, 'priority'), cerealParse_1.ParseUtils.getStringOrNull(o, 'crossStreets')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCURuleDoAlert Model: " + e.message);
        }
    };
    return SCURuleDoAlert;
}(SCURuleDo));
exports.SCURuleDoAlert = SCURuleDoAlert;
var SCURuleDoLog = /** @class */ (function (_super) {
    __extends(SCURuleDoLog, _super);
    function SCURuleDoLog(action, decorators, logFile, logText) {
        var _this = _super.call(this, action, decorators) || this;
        _this.action = action;
        _this.decorators = decorators;
        _this.logFile = logFile;
        _this.logText = logText;
        return _this;
    }
    SCURuleDoLog.prototype.toJson = function () {
        return {
            action: SCUActionType[this.action],
            decorators: this.decorators.map(function (d) { return d.toJson(); }),
            logFile: this.logFile,
            logText: this.logText,
        };
    };
    SCURuleDoLog.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCURuleDoLog(cerealParse_1.ParseUtils.getEnum(o, 'action', SCUActionType), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'decorators', SCURuleDoDecorator.parse, 'throw'), cerealParse_1.ParseUtils.getString(o, 'logFile'), cerealParse_1.ParseUtils.getString(o, 'logText')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCURuleDoLog Model: " + e.message);
        }
    };
    return SCURuleDoLog;
}(SCURuleDo));
exports.SCURuleDoLog = SCURuleDoLog;
var SCURuleDoMute = /** @class */ (function (_super) {
    __extends(SCURuleDoMute, _super);
    function SCURuleDoMute(action, decorators) {
        var _this = _super.call(this, action, decorators) || this;
        _this.action = action;
        _this.decorators = decorators;
        return _this;
    }
    SCURuleDoMute.prototype.toJson = function () {
        return {
            action: SCUActionType[this.action],
            decorators: this.decorators.map(function (d) { return d.toJson(); }),
        };
    };
    SCURuleDoMute.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCURuleDoMute(cerealParse_1.ParseUtils.getEnum(o, 'action', SCUActionType), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'decorators', SCURuleDoDecorator.parse, 'throw')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCURuleDoMute Model: " + e.message);
        }
    };
    return SCURuleDoMute;
}(SCURuleDo));
exports.SCURuleDoMute = SCURuleDoMute;
var SCURuleDoTone = /** @class */ (function (_super) {
    __extends(SCURuleDoTone, _super);
    function SCURuleDoTone(action, decorators, toneName, zones) {
        var _this = _super.call(this, action, decorators) || this;
        _this.action = action;
        _this.decorators = decorators;
        _this.toneName = toneName;
        _this.zones = zones;
        return _this;
    }
    SCURuleDoTone.prototype.toJson = function () {
        return {
            action: SCUActionType[this.action],
            decorators: this.decorators.map(function (d) { return d.toJson(); }),
            toneName: this.toneName,
            zones: this.zones,
        };
    };
    SCURuleDoTone.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCURuleDoTone(cerealParse_1.ParseUtils.getEnum(o, 'action', SCUActionType), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'decorators', SCURuleDoDecorator.parse, 'throw'), cerealParse_1.ParseUtils.getString(o, 'toneName'), cerealParse_1.ParseUtils.getArray(o, 'zones')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCURuleDoTone Model: " + e.message);
        }
    };
    return SCURuleDoTone;
}(SCURuleDo));
exports.SCURuleDoTone = SCURuleDoTone;
var SCURuleDoTextToSpeech = /** @class */ (function (_super) {
    __extends(SCURuleDoTextToSpeech, _super);
    function SCURuleDoTextToSpeech(action, decorators, ttsText, zones) {
        var _this = _super.call(this, action, decorators) || this;
        _this.action = action;
        _this.decorators = decorators;
        _this.ttsText = ttsText;
        _this.zones = zones;
        return _this;
    }
    SCURuleDoTextToSpeech.prototype.toJson = function () {
        return {
            action: SCUActionType[this.action],
            decorators: this.decorators.map(function (d) { return d.toJson(); }),
            ttsText: this.ttsText,
            zones: this.zones,
        };
    };
    SCURuleDoTextToSpeech.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCURuleDoTextToSpeech(cerealParse_1.ParseUtils.getEnum(o, 'action', SCUActionType), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'decorators', SCURuleDoDecorator.parse, 'throw'), cerealParse_1.ParseUtils.getString(o, 'ttsText'), cerealParse_1.ParseUtils.getArray(o, 'zones')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCURuleDoTextToSpeech Model: " + e.message);
        }
    };
    return SCURuleDoTextToSpeech;
}(SCURuleDo));
exports.SCURuleDoTextToSpeech = SCURuleDoTextToSpeech;
var SCURuleDoLight = /** @class */ (function (_super) {
    __extends(SCURuleDoLight, _super);
    function SCURuleDoLight(action, decorators, lightColor, lightIds) {
        var _this = _super.call(this, action, decorators) || this;
        _this.action = action;
        _this.decorators = decorators;
        _this.lightColor = lightColor;
        _this.lightIds = lightIds;
        return _this;
    }
    SCURuleDoLight.prototype.toJson = function () {
        return {
            action: SCUActionType[this.action],
            decorators: this.decorators.map(function (d) { return d.toJson(); }),
            lightColor: this.lightColor,
            lightIds: this.lightIds,
        };
    };
    SCURuleDoLight.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCURuleDoLight(cerealParse_1.ParseUtils.getEnum(o, 'action', SCUActionType), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'decorators', SCURuleDoDecorator.parse, 'throw'), cerealParse_1.ParseUtils.getString(o, 'lightColor'), cerealParse_1.ParseUtils.getArray(o, 'lightIds')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCURuleDoLight Model: " + e.message);
        }
    };
    return SCURuleDoLight;
}(SCURuleDo));
exports.SCURuleDoLight = SCURuleDoLight;
var SCURuleDoTest = /** @class */ (function (_super) {
    __extends(SCURuleDoTest, _super);
    function SCURuleDoTest(action, decorators) {
        var _this = _super.call(this, action, decorators) || this;
        _this.action = action;
        _this.decorators = decorators;
        return _this;
    }
    SCURuleDoTest.prototype.toJson = function () {
        return {
            action: SCUActionType[this.action],
            decorators: this.decorators.map(function (d) { return d.toJson(); }),
        };
    };
    SCURuleDoTest.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCURuleDoTest(cerealParse_1.ParseUtils.getEnum(o, 'action', SCUActionType), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'decorators', SCURuleDoDecorator.parse, 'throw')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCURuleDoTest Model: " + e.message);
        }
    };
    return SCURuleDoTest;
}(SCURuleDo));
exports.SCURuleDoTest = SCURuleDoTest;
var SCURuleMultiDo = /** @class */ (function (_super) {
    __extends(SCURuleMultiDo, _super);
    function SCURuleMultiDo(action, decorators, actions) {
        var _this = _super.call(this, action, decorators) || this;
        _this.action = action;
        _this.decorators = decorators;
        _this.actions = actions;
        return _this;
    }
    SCURuleMultiDo.prototype.toJson = function () {
        return {
            action: SCUActionType[this.action],
            decorators: this.decorators.map(function (d) { return d.toJson(); }),
            actions: this.actions.map(function (a) { return a.toJson(); }),
        };
    };
    SCURuleMultiDo.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCURuleMultiDo(cerealParse_1.ParseUtils.getEnum(o, 'action', SCUActionType), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'decorators', SCURuleDoDecorator.parse, 'throw'), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'actions', SCURuleDo.parse, 'throw')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCURuleMultiDo Model: " + e.message);
        }
    };
    return SCURuleMultiDo;
}(SCURuleDo));
exports.SCURuleMultiDo = SCURuleMultiDo;
var SCURuleDoScuTrigger = /** @class */ (function (_super) {
    __extends(SCURuleDoScuTrigger, _super);
    function SCURuleDoScuTrigger(action, decorators, trigger) {
        var _this = _super.call(this, action, decorators) || this;
        _this.action = action;
        _this.decorators = decorators;
        _this.trigger = trigger;
        return _this;
    }
    SCURuleDoScuTrigger.prototype.toJson = function () {
        return {
            action: SCUActionType[this.action],
            decorators: this.decorators.map(function (d) { return d.toJson(); }),
            trigger: this.trigger,
        };
    };
    SCURuleDoScuTrigger.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCURuleDoScuTrigger(cerealParse_1.ParseUtils.getEnum(o, 'action', SCUActionType), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'decorators', SCURuleDoDecorator.parse, 'throw'), cerealParse_1.ParseUtils.getString(o, 'trigger')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCURuleDoScuTrigger Model: " + e.message);
        }
    };
    return SCURuleDoScuTrigger;
}(SCURuleDo));
exports.SCURuleDoScuTrigger = SCURuleDoScuTrigger;
var SCURuleDoAudioChannelAction;
(function (SCURuleDoAudioChannelAction) {
    SCURuleDoAudioChannelAction[SCURuleDoAudioChannelAction["mute"] = 0] = "mute";
    SCURuleDoAudioChannelAction[SCURuleDoAudioChannelAction["unmute"] = 1] = "unmute";
})(SCURuleDoAudioChannelAction = exports.SCURuleDoAudioChannelAction || (exports.SCURuleDoAudioChannelAction = {}));
var SCURuleDoAudioChannel = /** @class */ (function (_super) {
    __extends(SCURuleDoAudioChannel, _super);
    function SCURuleDoAudioChannel(action, decorators, channel, channelAction) {
        var _this = _super.call(this, action, decorators) || this;
        _this.action = action;
        _this.decorators = decorators;
        _this.channel = channel;
        _this.channelAction = channelAction;
        return _this;
    }
    SCURuleDoAudioChannel.prototype.toJson = function () {
        return {
            action: SCUActionType[this.action],
            decorators: this.decorators.map(function (d) { return d.toJson(); }),
            channel: this.channel,
            channelAction: SCURuleDoAudioChannelAction[this.channelAction],
        };
    };
    SCURuleDoAudioChannel.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCURuleDoAudioChannel(cerealParse_1.ParseUtils.getEnum(o, 'action', SCUActionType), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'decorators', SCURuleDoDecorator.parse, 'throw'), cerealParse_1.ParseUtils.getString(o, 'channel'), cerealParse_1.ParseUtils.getEnum(o, 'channelAction', SCURuleDoAudioChannelAction)));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCURuleDoAudioChannel Model: " + e.message);
        }
    };
    return SCURuleDoAudioChannel;
}(SCURuleDo));
exports.SCURuleDoAudioChannel = SCURuleDoAudioChannel;
var SCURuleDoSendWebsocket = /** @class */ (function (_super) {
    __extends(SCURuleDoSendWebsocket, _super);
    function SCURuleDoSendWebsocket(action, decorators, id, message) {
        var _this = _super.call(this, action, decorators) || this;
        _this.action = action;
        _this.decorators = decorators;
        _this.id = id;
        _this.message = message;
        return _this;
    }
    SCURuleDoSendWebsocket.prototype.toJson = function () {
        return {
            action: SCUActionType[this.action],
            decorators: this.decorators.map(function (d) { return d.toJson(); }),
            id: this.id,
            message: this.message,
        };
    };
    SCURuleDoSendWebsocket.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCURuleDoSendWebsocket(cerealParse_1.ParseUtils.getEnum(o, 'action', SCUActionType), cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'decorators', SCURuleDoDecorator.parse, 'throw'), cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'message')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCURuleDoSendWebsocket Model: " + e.message);
        }
    };
    return SCURuleDoSendWebsocket;
}(SCURuleDo));
exports.SCURuleDoSendWebsocket = SCURuleDoSendWebsocket;
var SCURuleDoSleep = /** @class */ (function (_super) {
    __extends(SCURuleDoSleep, _super);
    function SCURuleDoSleep(decorators, millis) {
        var _this = _super.call(this, SCUActionType.sleep, decorators) || this;
        _this.decorators = decorators;
        _this.millis = millis;
        return _this;
    }
    SCURuleDoSleep.prototype.toJson = function () {
        return {
            action: SCUActionType[this.action],
            decorators: this.decorators.map(function (d) { return d.toJson(); }),
            millis: this.millis
        };
    };
    SCURuleDoSleep.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCURuleDoSleep(cerealParse_1.ParseUtils.getArrayOfSubobjects(o, 'decorators', SCURuleDoDecorator.parse, 'throw'), cerealParse_1.ParseUtils.getNumber(o, 'millis')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCURuleDoSleep Model: " + e.message);
        }
    };
    return SCURuleDoSleep;
}(SCURuleDo));
exports.SCURuleDoSleep = SCURuleDoSleep;
//# sourceMappingURL=scuRuleDo.js.map